module.exports = __webpack_public_path__ + "static/push-cf40a1b00110e4e95b2bce560cccabd1.png";